import { LinkSize, LinkVariant } from '@ui/common/components/Link/contracts';
import Link from '@ui/common/components/Link/Link';

export function NotFoundPage() {
  return (
    <div className="not-found">
      <h1 className="not-found__title">Page not found (404)</h1>
      <p className="not-found__description">
        The page you are looking for cannot be found. It either does not exist or it has been moved.
      </p>
      <div className="not-found__link-wrapper">
        <Link url="/" label="HOME" openInNewTab={false} variant={LinkVariant.Contained} size={LinkSize.lg} />
      </div>
    </div>
  );
}
